import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SectionTitle, Field } from "@/admin/ui";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const KEYS = ["iban", "iban_name", "currency", "tiktok", "telegram", "about_text", "ban_warning", "report_warning", "chat_reset_hours"];

export function AdminSettings() {
  const { refreshSite } = useAuth();
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => setS({})); }, []);
  const set = (k) => (e) => setS((p) => ({ ...p, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = {}; KEYS.forEach((k) => { if (s[k] !== undefined && s[k] !== null && s[k] !== "") body[k] = k === "chat_reset_hours" ? Number(s[k]) : s[k]; });
      await api.put("/admin/settings", body);
      await refreshSite();
      toast.success("Ayarlar kaydedildi ve siteye yansıdı");
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  if (!s) return <div className="h-40 rounded-2xl bg-slate-900/60 animate-pulse" />;

  return (
    <div>
      <SectionTitle eyebrow="Yapılandırma" title="Site Ayarları" />
      <p className="text-sm text-slate-400 -mt-4 mb-6">Ana sayfa başlık, arka plan, renk ve duyuru ayarları için <b className="text-cyan-300">Ana Sayfa</b> sekmesini kullan.</p>
      <form onSubmit={save} className="space-y-6 max-w-3xl">
        <div className="cx-glass rounded-2xl p-6 space-y-4">
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400">Ödeme</p>
          <div className="grid sm:grid-cols-[1fr_1fr_120px] gap-4">
            <Field label="IBAN"><Input data-testid="settings-iban" className="cx-input font-mono-cx" value={s.iban || ""} onChange={set("iban")} /></Field>
            <Field label="Alıcı Ad Soyad"><Input data-testid="settings-iban-name" className="cx-input" value={s.iban_name || ""} onChange={set("iban_name")} /></Field>
            <Field label="Para Birimi"><Input data-testid="settings-currency" className="cx-input" value={s.currency || ""} onChange={set("currency")} placeholder="₺" /></Field>
          </div>
          <Field label="'Gönderdim' Kırmızı Uyarı Metni"><Textarea data-testid="settings-ban-warning" className="cx-input min-h-[80px] h-auto" value={s.ban_warning || ""} onChange={set("ban_warning")} /></Field>
          <Field label="Report Uyarı Metni"><Textarea data-testid="settings-report-warning" className="cx-input min-h-[60px] h-auto" value={s.report_warning || ""} onChange={set("report_warning")} /></Field>
        </div>

        <div className="cx-glass rounded-2xl p-6 space-y-4">
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400">Sohbet</p>
          <Field label="Genel sohbet kaç saatte bir otomatik sıfırlansın?"><Input data-testid="settings-chat-reset-hours" type="number" step="0.5" min="0.5" className="cx-input w-40" value={s.chat_reset_hours ?? 2} onChange={set("chat_reset_hours")} /></Field>
          <p className="text-xs text-slate-500">Anında sıfırlamak için "Sohbet Kayıtları" sekmesindeki kırmızı butonu kullan.</p>
        </div>

        <div className="cx-glass rounded-2xl p-6 space-y-4">
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400">Hakkında & Sosyal</p>
          <Field label="Hakkında Metni"><Textarea data-testid="settings-about" className="cx-input min-h-[80px] h-auto" value={s.about_text || ""} onChange={set("about_text")} /></Field>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="TikTok"><Input data-testid="settings-tiktok" className="cx-input" value={s.tiktok || ""} onChange={set("tiktok")} /></Field>
            <Field label="Telegram"><Input data-testid="settings-telegram" className="cx-input" value={s.telegram || ""} onChange={set("telegram")} /></Field>
          </div>
        </div>

        <Button data-testid="settings-save" type="submit" disabled={saving} className="cx-btn-primary rounded-xl h-11 px-8">{saving ? "Kaydediliyor..." : "Ayarları Kaydet"}</Button>
      </form>
    </div>
  );
}
